import type { MediaType } from "@/types/media";

export const typeLabels: Record<MediaType, string> = {
  movie: "电影",
  tv: "电视剧",
  variety: "综艺",
};

export const typeSlugs: Record<MediaType, string> = {
  movie: "movie",
  tv: "tv",
  variety: "variety",
};

export function slugToType(slug?: string): MediaType | "all" {
  if (slug === "movie" || slug === "tv" || slug === "variety") return slug;
  return "all";
}